import styled from "styled-components";
import { onHoverDropShadow } from "../../../_components/styled/variable";

export const SelectOption = styled.div`
  border: 3px solid #323232;
  border-radius: 8px;
  margin: 8px 0;
  padding: 10px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;

  &:hover {
    box-shadow: 0px 0px 40px ${onHoverDropShadow};
    -webkit-box-shadow: 0px 0px 40px ${onHoverDropShadow};
    -moz-box-shadow: 0px 0px 40px ${onHoverDropShadow};
  }

  &.selected {
    border: 3px #ffac41 solid;
  }
`;
